// extracted by mini-css-extract-plugin
export default {"arrow_icon":"S1_ShippingAddress_arrow_icon__ln1Op","title_main":"S1_ShippingAddress_title_main__BauRn","stepper_txt":"S1_ShippingAddress_stepper_txt__MNiFR"};